import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    src: String,
    loadingText: String,
    errorText: String,
    useSkeleton: { type: Boolean, default: false }
  }

  connect() {
    if (!this.srcValue) return
    this.loadContent()
  }

  loadContent() {
    this.showLoading()

    fetch(this.srcValue, {
      headers: {
        "Accept": "application/json"
      }
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
        return response.json()
      })
      .then(data => {
        if (data.entries) {
          this.element.innerHTML = data.entries
        } else {
          this.showError("Invalid response format.")
        }
      })
      .catch(error => {
        console.error("Fetch error:", error)
        this.showError(this.errorTextValue || "Failed to load content.")
      })
  }

  showLoading() {
    if (this.useSkeletonValue) {
      this.element.innerHTML = this.skeletonHTML()
    } else {
      this.element.innerHTML = `
        <div style="text-align: center; padding: 1rem;">
          ${this.spinnerSVG()}
          <p>${this.loadingTextValue || "Loading..."}</p>
        </div>
      `
    }
  }

  showError(message) {
    this.element.innerHTML = `
      <div style="text-align: center; padding: 1rem; color: red;">
        <p>${message}</p>
        <button data-action="click->fetch-html#retry" style="margin-top: 0.5rem;">Retry</button>
      </div>
    `
  }

  retry() {
    this.loadContent()
  }

  spinnerSVG() {
    return `
      <svg width="40" height="40" viewBox="0 0 50 50" style="margin: auto;" xmlns="http://www.w3.org/2000/svg" fill="#555">
        <circle cx="25" cy="25" r="20" stroke="#ccc" stroke-width="5" fill="none" opacity="0.3"/>
        <path d="M25 5a20 20 0 0 1 20 20" stroke="#555" stroke-width="5" fill="none">
          <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
        </path>
      </svg>
    `
  }

  skeletonHTML() {
    return `
      <div style="background: #eee; border-radius: 6px; height: 100px; margin: 10px 0;"></div>
      <div style="background: #eee; border-radius: 6px; height: 20px; margin: 10px 0;"></div>
      <div style="background: #eee; border-radius: 6px; height: 20px; width: 80%; margin: 10px 0;"></div>
    `
  }
}
